module.exports = __webpack_public_path__ + "static/Apercu-Regular-bf38a35f60b487e6d1986bdaa45e01dd.ttf";